import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  toggle(event) {
    if (event.alreadyToggled) {
      return
    }

    this.#zone.toggleAttribute("hidden")
    this.element.classList.toggle("expanded", !this.#zone.hidden)
    this.buttonTarget.setAttribute("aria-expanded", !this.#zone.hidden)
    event.alreadyToggled = true
  }

  collapse() {
    if (this.#hasExpandedZone()) {
      this.toggle({})
    }
  }

  expand() {
    if (!this.#hasExpandedZone()) {
      this.toggle({})
    }
  }

  #hasExpandedZone() {
    return this.#zone.getAttribute("hidden") === null
  }

  get #zone() {
    return this.element.nextElementSibling
  }
}
